module.exports = __webpack_public_path__ + "img/collection-weddingRingsWaveDesign.5040443.jpg";